<template lang="html">
  <div class="container-fluid p-2 p-lg-5">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="row">
      <div class="col-12">
        <div class="card agent-member-card-responsive">
          <div class="card-header">
            Member List
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row search-form">
                  <div class="col-md-3 mt-3">
                    <input
                      type="text"
                      v-model="filter.name"
                      class="form-control"
                      placeholder="Name"
                    />
                  </div>
                  <div class="col-md-3 mt-3">
                    <input
                      type="text"
                      v-model="filter.phone"
                      class="form-control"
                      placeholder="Phone"
                    />
                  </div>
                  <div class="col-md-3 mt-3">
                    <input
                      type="text"
                      v-model="filter.email"
                      class="form-control"
                      placeholder="Email"
                    />
                  </div>
                  <!-- <div class="col-md-3 mt-1">
                                        <input type="text" v-model="filter.agent_name" class="form-control" placeholder="Agent Name">
                                    </div> -->
                  <div class="col-md-3 mt-3">
                    <button
                      class="btn btn-primary mr-1 fbutton"
                      @click="search()"
                    >
                      <i class="fas fa-search"></i> Search
                    </button>
                    <button class="btn btn-info fbutton" @click="reset()">
                      <i class="fas fa-sync"></i> Refresh
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive mt-4">
              <table class="common-table">
                <thead>
                  <tr>
                    <th
                      v-for="(value, key) in columns"
                      :key="key"
                      @click="sortBy(key)"
                      style="cursor:pointer;text-align: left;"
                    >
                      {{ value }}
                      <span v-if="filter.sortKey === key">
                        <i
                          v-if="filter.orderBy === 'asc'"
                          class="fas fa-sort-up"
                        ></i>
                        <i v-else class="fas fa-sort-down"></i>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in dataList" :key="data.id">
                    <td>{{ data.user_name }}</td>
                    <td class="text-left">{{ data.phone_or_email }}</td>
                    <!-- <td>{{ data.user_amount }}</td>
                                        <td>{{ data.agent_name }}</td>
                                        <td>{{ data.user_total_bet_amount }}</td>
                                        <td>{{ data.user_total_win_amount }}</td> -->
                    <!-- <td class="text-left">{{ data.user_total_lost_amount }}</td> -->
                  </tr>
                  <tr v-if="dataList.length === 0">
                    <!-- <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td> -->
                    <EmptyTableRow :colspan="Object.keys(columns).length + 1" />
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-pagination-minimal">
              <div class="table-pagination-row">
                <div
                  v-if="dataList.length > 0"
                  class="table-info-minimal left-align"
                >
                  Showing <span>{{ metaData.from }}</span> to
                  <span>{{ metaData.to }}</span> of
                  <span>{{ metaData.total }}</span> entries
                </div>
                <nav class="pagination-minimal">
                  <ul>
                    <li :class="{ disabled: metaData.prev_page_url === null }">
                      <button
                        @click.prevent="next(metaData.current_page - 1)"
                        :disabled="metaData.prev_page_url === null"
                      >
                        <i class="fas fa-angle-left"></i>
                      </button>
                    </li>
                    <li
                      v-for="page in metaData.last_page"
                      :key="page"
                      :class="{ active: metaData.current_page === page }"
                      v-if="
                        Math.abs(page - metaData.current_page) < 3 ||
                          page == metaData.last_page ||
                          page == 1
                      "
                    >
                      <button @click.prevent="next(page)">{{ page }}</button>
                    </li>
                    <li
                      :class="{
                        disabled: metaData.current_page === metaData.last_page,
                      }"
                    >
                      <button
                        @click.prevent="next(metaData.current_page + 1)"
                        :disabled="metaData.current_page === metaData.last_page"
                      >
                        <i class="fas fa-angle-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <b-modal
              id="bv-modal-delete"
              ref="my-modal"
              title="Delete"
              hide-footer
            >
              <p class="my-4">Are you sure to delete ?</p>
              <p class="my-4 text-danger">{{ alert }}</p>
              <b-button class="mt-3 btn-danger" block @click="deleteItem()"
                >Delete</b-button
              >
            </b-modal>
          </div>
          <!-- close card-body -->
        </div>
        <!-- close card -->
      </div>
      <!-- close col-md-12 -->
    </div>
    <!-- close row -->
  </div>
  <!-- close container-fluid -->
</template>

<script lang="js">
 import {
     mapState,
     mapActions
 } from 'vuex'
 import env from '../../enviorments'
 import Loading from 'vue-loading-overlay'
 import 'vue-loading-overlay/dist/vue-loading.css';
 import EmptyTableRow from "@/components/EmptyTableRow.vue";
 export default {
     name: 'withdrawList',
     metaInfo: {
         title: "Withdraw List",
         titleTemplate: "%s ← BXB",
     },
     components: {
         Loading,
         EmptyTableRow
     },
     data() {
         return {
             env,
             isLoading: false,
             fullPage: true,
             alert: "",
             id: '',
             userName: '',
             status: '',
             dataList: [],
             paymentMethod: [],
             permissions: '',
             columns: {
                 user_name: "Name",
                 user_phone_or_email: "Contact",
                 // user_amount: "Balance",
                 // agent_id: "Agent",
                 // user_total_bet_amount: "Bet",
                 // user_total_win_amount: "Win",
                 // user_total_lost_amount: "Lose",
             },
             filter: {
                 page: 1,
                 orderBy: "asc",
                 sortKey: "created_at",
                 limit: 10,
                 name: '',
                 phone: '',
                 email: '',
                 status: '',
                 payment_method_id: '',
                 from: '',
                 to: ''
             },
             fromInputType: 'text',
             toInputType: 'text',
             metaData: {
                 last_page: null,
                 current_page: 1,
                 from: null,
                 to: null,
                 total: null,
                 prev_page_url: null
             }
         }
     },
     watch: {
     '$route' (to, from) {
         this.fetchData()
     }
 },
     computed: {},
     methods: {
         ...mapActions({
             agentMemberListAction: 'agentMemberListAction',
         }),
         sortBy(column) {
             this.filter.sortKey = column
             if (this.filter.sortKey == column) {
                 if (this.filter.orderBy == "asc") {
                     this.filter.orderBy = "desc"
                 } else if (this.filter.orderBy == "desc") {
                     this.filter.orderBy = "asc"
                 }
             } else {
                 this.filter.orderBy = "asc"
             }
             this.fetchData()
         },
         async getPaymentMethod(){
	await this.paymentMethodAction().then(res => {
		this.paymentMethod = res.data
		this.isLoading = false
	}).catch(err => this.isLoading = true)
},
         async search() {
             this.filter.page = 1
             this.fetchData()
             this.$refs['my-modal'].hide()
         },
         async fetchData() {
             this.isLoading = true
             let option = this.filter
             await this.agentMemberListAction({
                 ...option
             }).then(res => {
                 if (res.success == true) {
                     this.dataList = res.data.data
                     this.metaData.last_page = res.data.meta.lastPage
                     this.metaData.current_page = res.data.meta.currentPage
                     this.metaData.prev_page_url = res.data.meta.prevPageUrl
                     this.metaData.from = res.data.meta.from
                     this.metaData.to = res.data.meta.to
                     this.metaData.total = res.data.meta.total
                     this.$router.replace({
                         path: 'agent-member-list',
                         query: {
                             page: this.filter.page,
                             orderBy: this.filter.orderBy,
                             sortKey: this.filter.sortKey,
                             name: this.filter.name,
                             phone: this.filter.phone,
                             email: this.filter.email,
                             status: this.filter.status,
                             payment_method_id: this.filter.payment_method_id,
                             from: this.filter.from,
                             to: this.filter.to
                         }
                     }).catch(()=>{})
                     this.isLoading = false;
                 }
             }).catch(err => this.isLoading = true)
         },
         next: function (page) {
             this.filter.page = page
             this.fetchData();
         },
         reset(){
             this.$router.replace({
                 path: 'agent-member-list',
                 query: {
                     page: 1,
                     orderBy: 'desc',
                     sortKey: 'created_at'
                 }
             }).catch(()=>{})
             this.$router.go()
         },
         editData(data) {
             this.id = data.id
             this.userName = data.user_name
             this.status = data.status
         },
         async editStatus() {
             this.isLoading = true
	let option = {
		id: this.id,
		status: this.status
	}
             console.log(this.status)
             if(this.status == 'completed'){
		await this.withdrawStatusCompletedAction({
			...option
		}).then(res => {
			if(res.success == false){
				this.alert = res.message
                     }else{
                         this.id = "",
                         this.status = "",
                         this.userName = "",
                         this.$refs['my-modal'].hide()
                     }
                     this.fetchData()
                     this.isLoading = false;
	    }).catch(err => this.isLoading = true)
             }

             if(this.status == 'failed'){
		await this.withdrawStatusFailedAction({
			...option
		}).then(res => {
			if(res.success == false){
				this.alert = res.message
                     }else{
                         this.id = "",
                         this.status = "",
                         this.userName = "",
                         this.$refs['my-modal'].hide()
                     }
                     this.fetchData()
                     this.isLoading = false;
	    }).catch(err => this.isLoading = true)
             }
         },
         deleteData(data){
             this.id = data.id
             this.alert = ""
         },
         async deleteItem() {
	this.isLoading = true
	let option = {
		id: this.id,
	}
	await this.withdrawDeleteAction({
		...option
	}).then(res => {
		if(res.status == 'fail'){
                     this.alert = res.message
                 }else{
                     this.$refs['my-modal'].hide()
                 }
                 this.fetchData()
                 this.isLoading = false;
	}).catch(err => this.isLoading = true)
},
         checkPermission: function (key) {
             if(key in this.permissions){
                 return true
             }else{
                 return false
             }
         }

     },
     async mounted() {
         let user = JSON.parse(window.localStorage.getItem('user'))
         this.permissions = user.permissions
         this.filter.page = this.$route.query.page
         this.filter.orderBy = this.$route.query.orderBy
         this.filter.sortKey = this.$route.query.sortKey
         this.filter.name = this.$route.query.name || ''
         this.filter.phone = this.$route.query.phone || ''
         this.filter.email = this.$route.query.email || ''
         this.filter.status = this.$route.query.status || ''
         this.filter.payment_method_id = this.$route.query.payment_method_id || ''
         this.filter.from = this.$route.query.from || ''
         this.filter.to = this.$route.query.to || ''
         await this.fetchData()
         await this.getPaymentMethod()
     }
 }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
  max-width: 900px;
}
.badge-16 {
  font-size: 16px;
}
</style>
